import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDialogConfiguration } from '@supoui/shared/model/modal/modal-dialog-configuration';
import { SERVER_API_URL } from '../../../app.constants';
import {VideoService} from "@supoui/help/services/video.service";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";

@Component({
    selector: 'app-video-stream-modal',
    templateUrl: './video-stream-modal.component.html',
    styleUrls: ['./video-stream-modal.component.scss'],
    standalone: false
})
export class VideoStreamModalComponent {
  modalDialogConfiguration: ModalDialogConfiguration;

  howToLoginVideoUrl: SafeUrl;
  howToLoginVideoPosterUrl: SafeUrl;

  constructor(public activeModal: NgbActiveModal) {}

  init(header: string, howToLoginVideoUrl: SafeUrl, howToLoginVideoPosterUrl: SafeUrl): void {
    this.modalDialogConfiguration = new ModalDialogConfiguration({
      headerText: header
    });
    this.howToLoginVideoUrl = howToLoginVideoUrl;
    this.howToLoginVideoPosterUrl = howToLoginVideoPosterUrl;
  }
}
